import { UseCaseError } from '../../../core/errors/UseCaseError';

export class SendFollowRequest {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(currentUserId, targetUserId) {
    try {
      if (!currentUserId || !targetUserId) {
        throw new UseCaseError('Les IDs des utilisateurs sont requis');
      }

      if (currentUserId === targetUserId) {
        throw new UseCaseError('Un utilisateur ne peut pas s\'abonner à lui-même');
      }

      await this.userRepository.sendFollowRequest(currentUserId, targetUserId);
      console.log(`Demande d'abonnement envoyée de ${currentUserId} à ${targetUserId}`);
      return true;
    } catch (error) {
      console.error('Erreur dans SendFollowRequest UseCase:', error);
      throw error;
    }
  }
} 